import React, { useEffect } from 'react';
import { AlertContainer, AlertMessage, DismissButton } from './styles';

const Alert = ({ message, type, onDismiss, duration = 5000 }) => {
  useEffect(() => {
    if (duration) {
      const timer = setTimeout(() => {
        onDismiss();
      }, duration);
      return () => clearTimeout(timer);
    }
  }, [duration, onDismiss]);

  return (
    <AlertMessage type={type}>
      <span>{message}</span>
      <DismissButton onClick={onDismiss}>×</DismissButton>
    </AlertMessage>
  );
};

export const AlertManager = ({ alerts, onDismiss }) => {
  return (
    <AlertContainer>
      {alerts.map((alert) => {

        const message = alert.error ?
          `${alert.error.customMessage}. ${alert.message}`
          : alert.message;
        const type = alert.error ? 
          alert.error.isCustomMessage ? 'warning' : alert.type
          : alert.type;

        return (
          <Alert
            key={alert.id}
            message={message}
            type={type}
            onDismiss={() => onDismiss(alert.id)}
            duration={alert.duration}
          />
        );

      })}
    </AlertContainer>
  );
}; 